<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section class="users-list-wrapper">
            <div class="card">
                <div class="row">
                    <div class="col-xl-6 col-lg-12 d-flex flex-column justify-content-between border-container-lg">
                        <div class="user-avatar-section">
                            <div class="d-flex justify-content-start">
                                <div *ngIf="user?.userName" class="m-2" style="
                                    width: 100px;
                                    height: 100px;
                                    background-color: rgb(97, 5, 255);
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    border: 3px solid white;
                                    border-radius: 12px; ">
                                    <p style="
                                      color: rgba(255, 255, 255, 0.922);
                                      text-transform: uppercase;
                                      text-align: center;
                                      margin: 0;
                                      font-size: xx-large;
                                      font-family: Georgia, 'Times New Roman', Times, serif;
                                      font-weight: bold;  ">
                                        {{ user.userName.slice(0, 2) }}
                                    </p>
                                </div>
                                <div class="d-flex flex-column ml-1">
                                    <div class="user-info mb-1 mt-1">
                                        <h4 class="mb-0">{{ user.userName }}</h4>
                                        <span class="card-text">{{ user.email }}</span>
                                        <h6 class="card-text">{{ getFormattedPhoneNumber(user.phoneNumber) }}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <ul ngbNav #navWithIcons="ngbNav" class="nav-tabs">
            <li ngbNavItem>
                <a ngbNavLink (click)="onNavChange()"><span [data-feather]="'layout'"></span> Sayfa Yetkileri</a>
                <ng-template ngbNavContent>
                    <div class="card" *blockUI="'section-block'">
                        <tree-root #treeComponent class="m-2" [nodes]="nodesAsync" [options]="optionsAsync"
                            (stateChange)="onEventBlur($event)">
                        </tree-root>
                        <div class="m-2">
                            <button class="btn btn-primary" (click)="saveUserPage()">Kaydet</button>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink><span [data-feather]="'award'"></span> İşlemler</a>
                <ng-template ngbNavContent>
                    <div class="row" id="basic-table">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="card-title">Kişiye Ait İşlemler</h4>
                                </div>
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>No</th>
                                                <th>Firma Adı</th>
                                                <th>Tür</th>
                                                <th>Durumu</th>
                                                <th>Ürün Sayısı</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of userTransaction">
                                                <td>{{item.documentNo ?? item.no}}</td>
                                                <td>{{item.companyName}}</td>
                                                <td> <span [ngClass]="getStatusClass(item?.kindName)"> {{item.kindName}} </span> </td>
                                                <td class="overflow-hidden"> {{getStatusText(item.status)}} </td>
                                                <td class="overflow-hidden"> {{item.productCount}} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink><span [data-feather]="'lock'"></span> Şifre Değiştir </a>
            </li>
        </ul>
        <div [ngbNavOutlet]="navWithIcons" class="mt-2"></div>
    </div>
</div>